import React, { ReactNode } from "react";
import { AssignedTo } from "@green0meter/api-client";

import { DropdownItem } from "./components/DropdownItem";

// TODO JS Option<T>
export interface Option {
  value: AssignedTo;
  label: ReactNode;
}

export const LABEL_ASSIGNMENT_DROPDOWN_OPTIONS: Option[] = [
  {
    value: AssignedTo.OnlyOwner,
    label: (
      <DropdownItem
        label={"dropdown.role.label.onlyOwner"}
        color="#1E3FC7"
        bgColor="#E9EBFB"
        borderColor="#C7CCF6"
      />
    ),
  },
  {
    value: AssignedTo.OwnerAndManagers,
    label: (
      <DropdownItem
        label={"dropdown.role.label.ownersManagers"}
        color="#FA963B"
        bgColor="#FFF4E4"
        borderColor="#FFE2BB"
      />
    ),
  },
  {
    value: AssignedTo.Everyone,
    label: (
      <DropdownItem
        label={"dropdown.role.label.everyone"}
        color="#269483"
        bgColor="#E2F4F2"
        borderColor="#B7E3DD"
      />
    ),
  },
  {
    value: AssignedTo.Hidden,
    label: (
      <DropdownItem
        label={"dropdown.role.label.hideFromEveryone"}
        color="#D32F2F"
        bgColor="#FFEBEE"
        borderColor="#FFCDD2"
      />
    ),
  },
  {
    value: AssignedTo.Mixed,
    label: (
      <DropdownItem
        label={"dropdown.role.label.mixed"}
        color="#A66AD7"
        bgColor="#F3E4FF"
        borderColor="#E3C2FE"
      />
    ),
  },
];

export { DropdownItem };
